import React, { useState, useEffect, useRef } from "react";
import {
  Input,
  ListGroup,
  ListGroupItem,
  Label,
  FormGroup,
  ListGroupItemHeading,
  ListGroupItemText,
} from "reactstrap";

import PopoverItem from "../common/PRpopover";


export default function HomeSelect(props) {
  const node = useRef();
  const [showProbType, setShowProbType] = useState(false);
  const [showProbTypeList, setShowProbTypeList] = useState(false);
 // const [problemtypeText, setProblemtypeText] = useState("");
  const [pTypes, setPTypes] = useState([]);

  useEffect(() => {
    setPTypes(props.problemTypes);
  }, []);

  const showHideForm = (e) => {
    setShowProbType(true);
  };


  const onChange = (e) => {

    if (e && e.target && e.target.value) {
      //setProblemtypeText(e.target.value);
      //  props.fstate.problemtype.value = e.target.value;
        props.fstate.problemtype.valueDesc = e.target.value;
      setShowProbType(false);

      setShowProbTypeList(true);
      let list = props.problemTypes.filter(
        (el) =>
          el.description.toUpperCase().indexOf(e.target.value.toUpperCase()) !==
            -1 ||
          el.keywords.toUpperCase().indexOf(e.target.value.toUpperCase()) !== -1
      );
      // console.log(test);
      setPTypes(list);
    } else {
      setPTypes(props.problemTypes);
      setShowProbType(true);
     // setProblemtypeText("");
        props.fstate.problemtype.value = "";
        props.fstate.problemtype.valueDesc = "";
    }
  };

  const onClickListItem = (e, a) => {
      props.fstate.problemtype.value = a.problemSid;
      props.fstate.problemtype.valueDesc = a.description;
    props.getQA(a.problemSid);
    //setProblemtypeText(a.description);
    setShowProbType(false);
    setShowProbTypeList(false);
  };


  return (
    <div ref={node}>


{!(
            props.fstate &&
            props.fstate.problemtype &&
            !props.fstate.problemtype.disable &&
            props.problemTypes
          ) ? (
            ""
          ) : (

      <FormGroup>
        <Label
          for="problemSelect"
          className={props.fstate.problemtype.fontWeight ? "label-font" : ""}
        >
          {props.translate(props.lang, props.fstate.problemtype.label)}{" "}
          {props.fstate.problemtype.required ? (
            <></>
          ) : (
            <span className="colorred">{props.translate(
                props.lang,"optionalSign")}</span>
          )}
        </Label>
        <PopoverItem elem={props.fstate.problemtype} translate={props.translate} lang={props.lang} />

        <div id="problemtypeHint" dangerouslySetInnerHTML={{ __html: props.translate(props.lang, "problemtypeHint") }} ></div>

        <ListGroup className="flex-select1">
          <ListGroupItem>
            <Input
              type="text"
              autoComplete="off"
              placeholder={props.translate(
                props.lang,
                props.fstate.problemtype.placeholder
              )}
              key={props.fstate.problemtype.name}
              name={props.fstate.problemtype.name}
              id={props.fstate.problemtype.name}
                                  value={
                                      (props.fstate.problemtype.valueDesc)?props.fstate.problemtype.valueDesc:""
                                      }
              valid={props.fstate.problemtype.status === 0}
              invalid={props.fstate.problemtype.status === 1}
              //onClick={(e) => {
              onFocus={(e) => {
                showHideForm(e);
                onChange(e);
              }}
              onChange={(e) => {
                onChange(e);
              }}
            />
          </ListGroupItem>

          {showProbTypeList ? (
            <div className="flex-select-list">
              {pTypes.map((a) => (
                <div className="flex-select-list-item" key={a.problemSid}>
                  <ListGroupItem
                    tag="button"
                    action
                    key={a.problemSid}
                    onClick={(e) => {
                      onClickListItem(e, a);
                    }}
                  >
                    <ListGroupItemHeading>
                      {" "}
                      {a.description}
                    </ListGroupItemHeading>
                    <ListGroupItemText>{a.problemCode} </ListGroupItemText>
                  </ListGroupItem>
                </div>
              ))}
            </div>
          ) : (
            ""
          )}

          {(showProbType && props.problemTypesCommon && props.problemTypesCommon.length>0) ? (
            <div>
              <ListGroupItem
                disabled
                tag="a"
                href="#"
                className="flex-select-list-item"
              >
            <span className="label-font">
                {props.translate(
                    props.lang,
                    "selectCommonRequestsLabel"
                )}
                  
                </span>
              </ListGroupItem>

              <div className="flex-select">
                <div className="flex-select-elem">
                  {props.problemTypesCommon.map((a, index) =>
                    index % 2 !== 0 ? (
                      ""
                    ) : (
                      <ListGroupItem
                        key={a.problemSid}
                        tag="button"
                        action
                        onClick={(e) => {
                          onClickListItem(e, a);
                        }}
                      >
                        {a.description}
                      </ListGroupItem>
                      //   <HomeSelectItem
                      //     key={a.problemSid}
                      //     item={a}
                      //     onClickListItem={onClickListItem}
                      //   />
                    )
                  )}
                </div>

                <div className="flex-select-elem">
                  {props.problemTypesCommon.map((a, index) =>
                    index % 2 !== 0 ? (
                      //   <HomeSelectItem
                      //     key={a.problemSid}
                      //     item={a}
                      //     onClickListItem={onClickListItem}
                      //   />
                      <ListGroupItem
                        key={a.problemSid}
                        tag="button"
                        action
                        onClick={(e) => {
                          onClickListItem(e, a);
                        }}
                      >
                        {a.description}
                      </ListGroupItem>
                    ) : (
                      ""
                    )
                  )}
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
        </ListGroup>
      </FormGroup>
  )}

    </div>
  );
}
